import { CATEGORIES, type Category } from '../record/constants'

export interface Filter {
  category: Category | ''
  keyword: string
  dateFrom: string
  dateTo: string
}

interface Props {
  filter: Filter
  onChange: (f: Filter) => void
}

export default function FilterBar({ filter, onChange }: Props) {
  function set<K extends keyof Filter>(key: K, val: Filter[K]) {
    onChange({ ...filter, [key]: val })
  }

  return (
    <div className="filter-bar">
      <input
        className="filter-keyword"
        placeholder="搜尋說明、備註…"
        value={filter.keyword}
        onChange={e => set('keyword', e.target.value)}
      />
      <select
        value={filter.category}
        onChange={e => set('category', e.target.value as Category | '')}
      >
        <option value="">所有類別</option>
        {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
      </select>
      <div className="filter-dates">
        <input type="date" value={filter.dateFrom} onChange={e => set('dateFrom', e.target.value)} />
        <span>～</span>
        <input type="date" value={filter.dateTo}   onChange={e => set('dateTo',   e.target.value)} />
      </div>
    </div>
  )
}
